import { DefaultNodeModel } from "@projectstorm/react-diagrams";
import { v4 as uuidv4 } from "uuid";

export class VariableNodeModel extends DefaultNodeModel {
  constructor({
    id = `VariableNode_${uuidv4()}`,
    color = "rgb(255,255,255)",
    position = { x: 100, y: 100 },
    nodeProperties = { Name: "New Variable Node", Value: "", Type: "Variable" },
  }) {
    super({
      id: id,
      name: nodeProperties.Name,
      color: color,
      extras: { properties: nodeProperties },
    });
    this.setPosition(position.x, position.y);
    this.addOutPort("Value");
  }
}
